import * as React from "react";
import { cn } from "@/lib/utils";

// Fixed color palette - 12 colors suitable for status indicators
export const FIXED_COLORS = [
  "#3B82F6", // Blue
  "#10B981", // Green
  "#EF4444", // Red
  "#F59E0B", // Yellow/Amber
  "#8B5CF6", // Purple
  "#F97316", // Orange
  "#EC4899", // Pink
  "#06B6D4", // Cyan
  "#6366F1", // Indigo
  "#6B7280", // Gray
  "#14B8A6", // Teal
  "#84CC16", // Lime
] as const;

export interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  disabled?: boolean;
  className?: string;
  colors?: readonly string[];
}

export function ColorPicker({
  value,
  onChange,
  disabled = false,
  className,
  colors = FIXED_COLORS,
}: ColorPickerProps) {
  const isValueInPalette = colors.includes(value as any);
  
  return (
    <div className={cn("space-y-2", className)}>
      <div className="flex flex-wrap gap-2">
        {colors.map((color) => (
          <button
            key={color}
            type="button"
            onClick={() => !disabled && onChange(color)}
            disabled={disabled}
            className={cn(
              "w-8 h-8 rounded-full border-2 transition-all cursor-pointer",
              "hover:scale-110 hover:shadow-md",
              "disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:scale-100",
              value === color
                ? "border-slate-800 shadow-md scale-110"
                : "border-slate-300 hover:border-slate-500"
            )}
            style={{ backgroundColor: color }}
            aria-label={`Select color ${color}`}
          />
        ))}
      </div>
    </div>
  );
}

